export type ExpirationStatus = 'valid' | 'warning' | 'expired' | 'empty';

export const EXPIRATION_WARNING_DAYS = 30;

export function getExpirationStatus(dateStr: string | null | undefined): ExpirationStatus {
  if (!dateStr?.trim()) return 'empty';

  const date = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(date.getTime())) return 'empty';

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffDays = Math.ceil((date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return 'expired';
  if (diffDays <= EXPIRATION_WARNING_DAYS) return 'warning';
  return 'valid';
}

export function getExpirationLabel(status: ExpirationStatus): string {
  switch (status) {
    case 'expired':
      return 'Expirado';
    case 'warning':
      return 'Por expirar';
    case 'valid':
      return 'Habilitado';
    default:
      return 'Sin fecha';
  }
}

export function getWorstExpirationStatus(dates: string[]): ExpirationStatus {
  const priorities: Record<ExpirationStatus, number> = {
    expired: 4,
    warning: 3,
    empty: 2,
    valid: 1,
  };

  let worst: ExpirationStatus = 'valid';
  dates.forEach((date) => {
    const status = getExpirationStatus(date);
    if (priorities[status] > priorities[worst]) {
      worst = status;
    }
  });
  return worst;
}

export function expirationStatusToTone(
  status: ExpirationStatus
): 'ok' | 'warn' | 'error' | 'muted' {
  switch (status) {
    case 'expired':
      return 'error';
    case 'warning':
      return 'warn';
    case 'valid':
      return 'ok';
    default:
      return 'muted';
  }
}
